import React, { Component } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import Button from '../Buttons/Button';
import { customGaEvent, GA_EVENTS } from '../../utils/ga';
import './CopyLinkToClipboard.scss';

class CopyLinkToClipboard extends Component {
  constructor() {
    super();
    this.state = {
      copied: false,
    };
  }
  handleCopy = isUrl => {
    const { type, sendHubspotEvent } = this.props;
    sendHubspotEvent({
      event: isUrl ? 'clickCopyShareLink' : 'clickEmbediFrame',
    });
    this.setState({ copied: true }, () => {
      customGaEvent({
        action: GA_EVENTS.COPY,
        label: type,
      });
      setTimeout(() => this.setState({ copied: false }), 5000);
    });
  };

  render() {
    const { copied } = this.state;
    const { shareUrl, type } = this.props;
    const isUrl = type === 'share';

    return (
      <React.Fragment>
        <CopyToClipboard
          key="copy"
          text={shareUrl}
          onCopy={() => this.handleCopy(isUrl)}
        >
          <Button
            className="copy-btn"
            data-cy={isUrl ? 'copy-url-btn' : 'copy-embed-btn'}
            aria-label={`copy ${isUrl ? 'share url' : 'iframe embed'}`}
          >
            <i aria-hidden="true" className="material-icons">
              content_copy
            </i>
            &nbsp;Copy
          </Button>
        </CopyToClipboard>
        {copied && (
          <p key="copy-success" className="copy-success">
            Copied to clipboard
          </p>
        )}
      </React.Fragment>
    );
  }
}

export default CopyLinkToClipboard;
